import React, { useRef } from 'react';
import Link from './Link';

import BlockContent from '@sanity/block-content-to-react';
import homeAboutRichText from '../serializers/homeAboutRichText';
import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ description, image, link }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);
  return (
    <section
      ref={intersectionRef}
      className={classNames('df fdc fdr--lg bb--dark-brown reveal', {
        revealed: isIntersected,
      })}
    >
      <div className="image-panel x br--dark-brown--lg">
        <picture>
          <source
            srcSet={`${image.url}?w=1200&auto=format&q=100`}
            media="(min-width: 1000px)"
          />
          <source
            srcSet={`${image.url}?w=600&auto=format&q=100`}
            media="(min-width: 600px)"
          />
          <img
            alt={image.alt}
            className="db"
            src={`${image.url}?w=600&auto=format&q=100`}
          />
        </picture>
      </div>
      {description && (
        <div className="desc-panel x p2 pt5 pb5 aie">
          <BlockContent blocks={description} serializers={homeAboutRichText} />
          <Link
            className="serif--md pt2 dib pt5--lg link--underline"
            {...link}
          />
        </div>
      )}
    </section>
  );
};
